import { useState } from "react";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { Banknote, Bot, Flag, Globe, Trophy, Users } from "lucide-react";
import TabNav from "../../components/TabNav/TabNav";
import MetricsToggle from "../../components/MetricsToggle/MetricsToggle";
import { MetricsContext } from "./AdminMetrics";
import AdminUsers from "./AdminUsers";
import AdminBots from "./AdminBots";
import AdminPayments from "./AdminPayments";
import AdminTopSellers from "./AdminTopSellers";
import AdminReports from "./AdminReports";
import AdminDomains from "./AdminDomains";
import "./Admin.css";

export const ADMIN_BASE = "/dashboard/admin";

// Cada seção é uma subrota (/dashboard/admin/<id>): dá pra linkar, voltar e
// abrir uma seção já filtrada pela URL (ex.: bots?owner_id=3).
const SECTIONS = [
  { id: "pagamentos", label: "Pagamentos", icon: <Banknote size={16} />, element: <AdminPayments />, metrics: true },
  { id: "usuarios", label: "Usuários", icon: <Users size={16} />, element: <AdminUsers />, metrics: true },
  { id: "bots", label: "Bots", icon: <Bot size={16} />, element: <AdminBots /> },
  { id: "denuncias", label: "Denúncias", icon: <Flag size={16} />, element: <AdminReports />, metrics: true },
  { id: "top-sellers", label: "Top Sellers", icon: <Trophy size={16} />, element: <AdminTopSellers /> },
  { id: "dominios", label: "Domínios", icon: <Globe size={16} />, element: <AdminDomains /> },
];

const DEFAULT_SECTION = SECTIONS[0].id;

export default function Admin() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const current = pathname.slice(ADMIN_BASE.length).split("/").filter(Boolean)[0];
  const section = SECTIONS.find((s) => s.id === current);
  const [showMetrics, setShowMetrics] = useState(false);

  return (
    <div className="page">
      <div className="page-header-with-filters" role="banner">
        <div className="page-header-content flex items-center justify-between gap-3 flex-wrap">
          <div>
            <h1 className="title">Painel Administrativo</h1>
            <p>Monitore a Spectrum</p>
          </div>
          {section?.metrics && (
            <MetricsToggle open={showMetrics} onToggle={() => setShowMetrics((v) => !v)} />
          )}
        </div>
      </div>

      {/* O cabeçalho (como o de Vendas) não tem margem embaixo: o respiro fica aqui. */}
      <div className="mt-6">
        <TabNav
          tabs={SECTIONS}
          activeTab={current}
          onTabChange={(id) => navigate(`${ADMIN_BASE}/${id}`)}
        />
      </div>

      <MetricsContext.Provider value={showMetrics}>
      <Routes>
        <Route index element={<Navigate to={DEFAULT_SECTION} replace />} />
        {SECTIONS.map((s) => (
          <Route key={s.id} path={s.id} element={s.element} />
        ))}
        <Route path="*" element={<Navigate to={`${ADMIN_BASE}/${DEFAULT_SECTION}`} replace />} />
      </Routes>
      </MetricsContext.Provider>
    </div>
  );
}
